/**
 * Wishlist Page — renders the saved items grid from window.LaTiendaWishlist.
 * Re-renders on 'wishlist:changed' event (when user removes items).
 */
(function () {
  'use strict';

  var section = document.querySelector('[data-wishlist-section]');
  if (!section) return;

  var grid = section.querySelector('[data-wishlist-grid]');
  var empty = section.querySelector('[data-wishlist-empty]');
  var subtitle = section.querySelector('[data-wishlist-subtitle]');
  var footer = section.querySelector('[data-wishlist-footer]');
  var clearBtn = section.querySelector('[data-wishlist-clear]');

  function escapeHtml(s) {
    if (s == null) return '';
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(String(s)));
    return d.innerHTML;
  }

  function escapeAttr(s) {
    if (s == null) return '';
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function formatMoney(price) {
    var p = parseFloat(price) || 0;
    return 'EGP ' + Math.round(p).toLocaleString('en-EG');
  }

  function buildCard(item) {
    var onSale = item.compare_at_price && parseFloat(item.compare_at_price) > parseFloat(item.price);
    var price = formatMoney(item.price);
    var compare = onSale ? formatMoney(item.compare_at_price) : '';

    var html = '<article class="wishlist-card">';

    html += '<a href="' + escapeAttr(item.url) + '" class="wishlist-card__image-link">';
    if (item.image) {
      html += '<img src="' + escapeAttr(item.image) + '" alt="' + escapeAttr(item.title) + '" class="wishlist-card__image" loading="lazy" width="400" height="400" '
        + 'onerror="this.style.display=\'none\';">';
    } else {
      html += '<div class="wishlist-card__image-placeholder"></div>';
    }
    html += '</a>';

    html += '<div class="wishlist-card__body">';
    if (item.vendor) {
      html += '<div class="wishlist-card__vendor">' + escapeHtml(item.vendor) + '</div>';
    }
    html += '<a href="' + escapeAttr(item.url) + '" class="wishlist-card__title">' + escapeHtml(item.title) + '</a>';
    html += '<div class="wishlist-card__price' + (onSale ? ' wishlist-card__price--on-sale' : '') + '">';
    html += '<span class="wishlist-card__price-current">' + price + '</span>';
    if (onSale) html += '<span class="wishlist-card__price-compare">' + compare + '</span>';
    html += '</div>';
    html += '<div class="wishlist-card__actions">';
    html += '<a href="' + escapeAttr(item.url) + '" class="btn btn-primary wishlist-card__view-btn">View product</a>';
    html += '<button type="button" class="wishlist-card__remove-btn" data-wishlist-remove="' + escapeAttr(item.handle) + '" aria-label="Remove from wishlist">';
    html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>';
    html += '</button>';
    html += '</div>';
    html += '</div>';

    html += '</article>';
    return html;
  }

  function render() {
    var items = window.LaTiendaWishlist ? window.LaTiendaWishlist.get() : [];
    if (items.length === 0) {
      grid.innerHTML = '';
      empty.removeAttribute('hidden');
      footer.setAttribute('hidden', '');
      subtitle.textContent = 'You haven\'t saved any rackets yet.';
      return;
    }
    empty.setAttribute('hidden', '');
    footer.removeAttribute('hidden');
    var noun = items.length === 1 ? 'racket' : 'items';
    subtitle.textContent = items.length + ' ' + noun + ' saved.';
    grid.innerHTML = items.map(buildCard).join('');

    grid.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.LaTiendaWishlist) window.LaTiendaWishlist.remove(btn.dataset.wishlistRemove);
      });
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      if (window.LaTiendaWishlist && confirm('Remove all rackets from your wishlist?')) {
        window.LaTiendaWishlist.clear();
      }
    });
  }

  document.addEventListener('wishlist:changed', render);

  // Wait for wishlist.js to set up window.LaTiendaWishlist (it loads with defer too)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    // Slight delay to allow wishlist.js to register
    setTimeout(render, 50);
  }
})();
